import React, { useEffect } from 'react';
import { MyAccountController, MyAccountHomeController } from 'src/controllers/MyAccount';
import Main from '@components/Layout/Main';
import useTranslations from '@hooks/useTranslations';
import routes from 'src/constants/routes';
import Spinner from '@components/Spinner';
import { useUserDuck } from '@hooks/useUserDuck';
import { useGTM } from '@hooks/useGTM';
import { useDispatch } from 'react-redux';
import { theme } from 'src/styles/theme';
import { NETWORK_STATUS_ERROR, NETWORK_STATUS_DONE } from 'src/redux/redux.interface';
import useCustomRouter from '@hooks/useCustomRouter';
import { ContextWithStore } from '@utils/getInitialProps/@types';
import { updateGeneralContext } from '@utils/getInitialProps/common';

const MyAccount = () => {
    const router = useCustomRouter();
    const { t } = useTranslations();
    const { pushMyAccountPageLoad } = useGTM();

    const {
        summary: { accountStatus, accountError },
        FetchMyAccountSummary,
    } = useUserDuck();

    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(FetchMyAccountSummary());
        pushMyAccountPageLoad(false);
    }, []);

    useEffect(() => {
        if (accountStatus === NETWORK_STATUS_ERROR) {
            if (accountError.code === 403) {
                router.replace(routes.LOGIN);
            } else {
                // todo: Unhandled error, send error to logger
                console.error('User not signed in', accountError);
            }
        }
    }, [accountStatus]);

    if (accountStatus === NETWORK_STATUS_DONE) {
        return (
            <Main title={t('myaccount.tabTitle')}>
                <MyAccountController>
                    <MyAccountHomeController />
                </MyAccountController>
            </Main>
        );
    }

    return (
        <Main title={t('myaccount.tabTitle')}>
            <MyAccountController>
                <div className="my-account-spinner">
                    <Spinner size={50} border={5} color={theme.colors.grey10} />
                </div>
            </MyAccountController>
        </Main>
    );
};

MyAccount.getInitialProps = async (ctx: ContextWithStore) => {
    await updateGeneralContext(ctx);

    return {
        namespacesRequired: ['common'],
    };
};

export default MyAccount;
